module.exports = __webpack_public_path__ + "img/labelItem4@2x.c3e9213c.png";